/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from "react";
import {withStyles, createTheme, ThemeProvider} from '@material-ui/core/styles'

import DOCViewer from "./../DOC/DOCViewer";
import TableViewer from "./../TABLE/TableViewer/TABLEViewer";
import doc_viewer_map from "./../../Config/document_config";
import table_viewer_map from "./../../Config/table_config";
import image_viewer_map from "./../../Config/image_config";
import ImageViewer from "./../IMAGE/ImageViewer";

import Attachment from '../JSON/components/Attachment'

import Fab from '@material-ui/core/Fab';
import { AttachFile } from "@material-ui/icons";  

import Actions from "../../../../../fluid/Actions/ActionFactory";

const blue_theme = createTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc014e",
    },
  },
});

const styles = theme => ({
  fab: {
    position: 'absolute',
    zIndex : 9999
  }
})
class DataViewer extends Component {
  state = {
    received_wv_schema : false,
    attachment_object : null
  };

  componentDidMount () {
    console.log("Data Viewer Props On load : ", this.props)
    if (this.props.re_attach) {
      let file_name = this.props.record.source_link.src_file_name
      Actions('http_request', {
        url : "/sainapse/world_view_server/attachment_metadata",
        method : 'post',
        data : {
            wv_id : this.props.record.source_link.file_id,
            wv_server_name : this.props.record.source_link.symbolic_server_name
        },
        params : {
          display_file_name : file_name
        }
      }).then(res => {
        this.setState({...this.state, attachment_object : res.data})
      })
    }
  }

  componentDidUpdate() {
    console.log("Data Viewer Props Updated");
  }

  renderViewer = () => {
    let sub_type = this.props.record.iu_record_src_info.iu_content_type
      .sub_type;
    //doc
    let isDoc = false;
    let isTable = false;
    let isImage = false;

    if ( image_viewer_map.findIndex((imageTypeObj) => imageTypeObj.sub_type.includes(sub_type) ) !== -1 ){
      isImage = true;
    } else if ( doc_viewer_map.findIndex((docTypeObj) => docTypeObj.sub_type.includes(sub_type)) !== -1 ) {
      isDoc = true;
    }  else if (table_viewer_map.findIndex((tableTypeObj) => tableTypeObj.sub_type.includes(sub_type)) !== -1) {
      isTable = true;
    } 

    let attachment_object = {
      file_name : this.props.record.source_link.src_file_name,
      file_wv_address : {
        wv_id : this.props.record.source_link.file_id,
        wv_server_name : this.props.record.source_link.symbolic_server_name
      }
    }

    //document viewer
    if (isDoc) {
      return <DOCViewer {...this.props} attachment_object = {attachment_object}></DOCViewer>;
    } else if (isTable) {
      return <TableViewer {...this.props} attachment_object = {attachment_object}></TableViewer>;
    } else if (isImage) {
      return <ImageViewer {...this.props} attachment_object = {attachment_object}></ImageViewer>
    } else {
      return <div>invalid doc subtype</div>;
    }
  };

  render() {
    const { classes } = this.props
    return (
      <ThemeProvider theme = {blue_theme}>
        <div style = {{position : 'relative'}}>
          {this.state.attachment_object && <div style = {{position : 'absolute', top: '50px', left: '20px', width : '50px', zIndex : 5}}>
            <Attachment
                width = '100%'
                attachment = {this.state.attachment_object}
                show_title = {false}
                show_view = {false}
                server_name = {this.state.attachment_object.file_wv_address.wv_server_name}
                file_id = {this.state.attachment_object.file_wv_address.wv_id}
                file_name = {this.state.attachment_object.file_name}
                file_type = {this.state.attachment_object.content_type}
                path = {this.state.attachment_object.content_type}
                record = {this.props.record}
                drl_url = {this.props.drl_url}
                re_attach = {this.props.re_attach}
                attach_options = {this.props.attach_options}
                re_attach_attachment = {(field_option, attachment_object) => this.props.re_attach_attachment(field_option, attachment_object)}
            />
          </div>}
          {this.renderViewer()}
        </div>
      </ThemeProvider>);
  }
}

export default withStyles(styles)(DataViewer);
